export default {
  watch: {
    '$i18n.locale' () {
      this.$emit('updateHead')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/updateHead.js